// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MinuCircle: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 13 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 13">
            <path
                fill="currentcolor"
                d="M6 12.5c3.305 0 6-2.695 6-6s-2.695-6-6-6-6 2.695-6 6 2.695 6 6 6ZM3.937 5.937h4.126a.57.57 0 0 1 .562.563.57.57 0 0 1-.563.563H3.939a.57.57 0 0 1-.563-.563.57.57 0 0 1 .563-.563Z"
            />
        </svg>
    );
};

export default React.memo(MinuCircle);
